import { render, staticRenderFns } from "./CasasDecimaisQuantidade.vue?vue&type=template&id=b66331dc&scoped=true&"
import script from "./CasasDecimaisQuantidade.vue?vue&type=script&setup=true&lang=js&"
export * from "./CasasDecimaisQuantidade.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b66331dc",
  null
  
)

export default component.exports